import { lazy, Suspense, useEffect, useState } from "react";
import { isIOS } from "react-device-detect";
import { Provider } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import Toast from "./Toast";
import Loader from "./components/Loader";
import App from "./pages/App";

const UserForm = lazy(() =>import("./pages/form/UserForm"));
const UserFormStatus = lazy(() =>import("./pages/form/UserFormStatus"));
const Login = lazy(() =>import("./pages/login/Login"));
const PaymentLink = lazy(() =>import("./pages/payment/PaymentLink"));
const PaymentStatus = lazy(() =>import("./pages/payment/PaymentStatus"));

// import PaymentStatus from "./pages/payment/PaymentStatus";
// import PaymentLink from "./pages/payment/PaymentLink";
// import Login from "./pages/login/Login";
// import UserFormStatus from "./pages/form/UserFormStatus";

export default function Main(props) {
  
  const [isInspectionMode,setIsInspectionMode] = useState(false)

  useEffect(()=>{
    detectDevTools();
  },[])
  
  
  function detectDevTools() {
    const devToolsOpened = () => {
      alert("Please close the inspection mode and reload the page");
      setIsInspectionMode(true)
    };
   
    const devToolsClosed = () => {
      console.log("Developer Tools is closed");
    };
   
    let threshold = 150;
    let widthThreshold = window.outerWidth - window.innerWidth > threshold;
    let heightThreshold = window.outerHeight - window.innerHeight > threshold;
   
    if ((widthThreshold || heightThreshold) && !isIOS) {
      devToolsOpened();
    } else {
      devToolsClosed();
    }
  }
  if(!isInspectionMode){
    return (
        <Provider store={props.store}>
          <Toast>
            <Suspense fallback={<Loader show={true} />}>
              <Routes>
                <Route  index element={<Navigate to="/login" replace />} />
                <Route  path='/login' element={<Login/>}/>
                <Route  path='/:formId' element={<UserForm/>}/>
                <Route  path='/:formId/status' element={<UserFormStatus/>}/>
                <Route  path='/payment/status' element={<PaymentStatus/>}/>
                <Route  path='/app/*' element={<App/>}/>
                <Route  path='/pay' element={<PaymentLink/>}/>
              </Routes>
            </Suspense>
          </Toast>
        </Provider>
    );
  }
}